module.exports = __webpack_public_path__ + "static/IMG_3547-a1499ef10fedf9c919dd4732e08b5085.jpg";